import { isAxiosError } from 'axios'
import { type CaptureErrorOptions } from 'elastic-apm-node'

import { apmGetAxiosErrorCustomContext } from './apmGetAxiosErrorCustomContext'

export const apmCaptureError = (error: Error): void => {
  if (globalThis.serverSideApmInstance) {
    const options: CaptureErrorOptions = {}

    if (isAxiosError(error)) {
      options.custom = apmGetAxiosErrorCustomContext(error)
    }

    globalThis.serverSideApmInstance.captureError(error, options)
  } else if (globalThis.clientSideApmInstance) {
    globalThis.clientSideApmInstance.captureError(error)
  } else {
    if (isAxiosError(error)) {
      // clean up error object to reduce the huge payload in the console
      delete error.config
      delete error.request
      delete error.response
    }

    // eslint-disable-next-line no-console -- debugging purpose during development
    console.error(error)
  }
}
